import { IsAsyncIterable, IsIterable, IsObject } from '../../../../../../helpers';
export function NormalizeFromIterableObservableOptionsAndIterable(iterable, options = {}) {
    const args = {
        iterable
    };
    const isIterable = IsIterable(iterable);
    const isAsyncIterable = IsAsyncIterable(iterable);
    if (isAsyncIterable || isIterable) {
        args.iterable = iterable;
        if (IsObject(options)) {
            if (options.isAsync === void 0) {
                args.isAsync = isAsyncIterable;
            }
            else if (typeof options.isAsync === 'boolean') {
                if (options.isAsync && !isAsyncIterable) {
                    throw new Error(`options.isAsync is true but the provided iterable is not an AsyncIterable`);
                }
                else {
                    args.isAsync = options.isAsync;
                }
            }
            else {
                throw new TypeError(`Expected boolean or void as FromIterableObservable.options.isAsync`);
            }
        }
        else {
            throw new TypeError(`Expected object or void as options`);
        }
    }
    else {
        throw new TypeError(`Expected Iterable or AsyncIterable as iterable`);
    }
    return args;
}
//# sourceMappingURL=functions.js.map